import React, { useEffect, useState } from "react";
import { Form, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { Authority, Country } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useLanguage } from "../../../../contexts";

const authorityController = new Authority();
const countryController   = new Country();

export function AuthorityForm({ authority, close, onReload }) {
  const { accessToken } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [countryOptions, setCountryOptions] = useState([]);

  useEffect(() => {
    countryController.getCountries(accessToken, true).then((countries) => {
      setCountryOptions(countries.map((c) => ({ key: c._id, value: c._id, text: c.name })));
    }).catch(() => {});
  }, []);

  const getId = (val) => (val && typeof val === "object" ? val._id : val) || "";

  const formik = useFormik({
    initialValues: {
      code:    authority?.code    || "",
      name:    authority?.name    || "",
      country: getId(authority?.country),
    },
    validationSchema: Yup.object({
      code: Yup.string().required("El código es requerido"),
      name: Yup.string().required("El nombre es requerido"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (authority) {
          await authorityController.updateAuthority(accessToken, authority._id, values);
          toast.success(t("updated"));
        } else {
          await authorityController.createAuthority(accessToken, values);
          toast.success(t("created"));
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || t("error"));
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input
        label={<label>{t("code")} <span style={{ color: "#C0392B" }}>*</span></label>}
        name="code"
        value={formik.values.code}
        onChange={formik.handleChange}
        error={formik.errors.code}
        placeholder="Ej: Sa"
      />
      <Form.Input
        label={<label>{t("name")} <span style={{ color: "#C0392B" }}>*</span></label>}
        name="name"
        value={formik.values.name}
        onChange={formik.handleChange}
        error={formik.errors.name}
        placeholder="Ej:Salud"
      />
      <Form.Field>
        <label>{t("country") || "País"}</label>
        <Dropdown
          fluid selection clearable
          options={countryOptions}
          value={formik.values.country}
          onChange={(_, { value }) => formik.setFieldValue("country", value || null)}
          placeholder={t("all_countries") || "Aplica a todos los países"}
        />
      </Form.Field>
      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        <button type="submit" disabled={formik.isSubmitting} style={{ background: "#4A7FA5", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer", opacity: formik.isSubmitting ? 0.55 : 1 }}>
          {formik.isSubmitting ? "…" : (authority ? t("update") : t("create"))}
        </button>
        <button type="button" onClick={close} style={{ background: "#9BAFC4", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer" }}>
          {t("cancel")}
        </button>
      </div>
    </Form>
  );
}
